import React from 'react';
import PropTypes from 'prop-types';

const Apartment = ({ color = '#F87052', outlineColor = '#224251', secondColor = '#BCC6CA', ...props }) => (
  <svg width={99} height={84} viewBox="0 0 99 84" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M97.106 14.383c.078.332.117.675.117 1.012 0 2.614-2.248 4.731-5.018 4.731-2.77 0-5.018-2.117-5.018-4.731 0-.337.04-.68.117-1.012h9.802Z"
      fill="#fff"
    />
    <path
      d="M63.98 8.298H7.526v73.928h56.452V8.298ZM20.7 1.792h-4.391v6.21h4.39v-6.21ZM55.198 1.792h-4.39v6.21h4.39v-6.21Z"
      fill="#fff"
    />
    <path d="M63.878 12.42H7.527v30.754h56.35V12.42Z" fill={color} />
    <path
      d="M63.877 44.357H7.527c-.693 0-1.255-.53-1.255-1.183V12.42c0-.653.562-1.183 1.255-1.183h56.35c.693 0 1.255.53 1.255 1.183v30.754c0 .653-.562 1.183-1.255 1.183ZM8.781 41.99h53.842V13.603H8.78V41.99Z"
      fill={color}
    />
    <path
      d="M63.979 83.928H7.527c-.693 0-1.255-.529-1.255-1.182V47.26c0-.653.562-1.183 1.255-1.183.692 0 1.254.53 1.254 1.183v34.303h53.943V47.26c0-.653.562-1.183 1.255-1.183.692 0 1.254.53 1.254 1.183v35.486c0 .653-.561 1.182-1.254 1.182ZM7.527 44.357c-.693 0-1.255-.53-1.255-1.183v-29.73c0-.654.562-1.184 1.255-1.184.692 0 1.254.53 1.254 1.183v29.731c0 .653-.562 1.183-1.254 1.183ZM63.979 44.357c-.693 0-1.255-.53-1.255-1.183V12.42c0-.653.562-1.183 1.255-1.183.692 0 1.254.53 1.254 1.183v30.754c0 .653-.561 1.183-1.254 1.183Z"
      fill={outlineColor}
    />
    <path
      d="M67.115 48.443H4.391c-.693 0-1.255-.53-1.255-1.183s.562-1.183 1.255-1.183h62.724c.693 0 1.255.53 1.255 1.183 0 .654-.562 1.183-1.255 1.183ZM67.115 13.603H4.391c-.693 0-1.255-.53-1.255-1.183s.562-1.183 1.255-1.183h62.724c.693 0 1.255.53 1.255 1.183s-.562 1.183-1.255 1.183ZM20.7 9.463c-.693 0-1.255-.53-1.255-1.183V2.366h-1.882V8.28c0 .653-.562 1.183-1.254 1.183-.693 0-1.255-.53-1.255-1.183V1.183C15.054.53 15.616 0 16.31 0h4.39c.693 0 1.255.53 1.255 1.183V8.28c0 .653-.562 1.183-1.255 1.183ZM55.198 9.463c-.693 0-1.255-.53-1.255-1.183V2.366h-1.881V8.28c0 .653-.562 1.183-1.255 1.183-.692 0-1.254-.53-1.254-1.183V1.183C49.553.53 50.115 0 50.807 0h4.391c.693 0 1.255.53 1.255 1.183V8.28c0 .653-.563 1.183-1.255 1.183Z"
      fill={outlineColor}
    />
    <path
      d="M23.208 2.366H13.8c-.692 0-1.254-.53-1.254-1.183S13.107 0 13.799 0h9.41c.692 0 1.254.53 1.254 1.183s-.562 1.183-1.255 1.183ZM57.706 2.366h-9.409c-.692 0-1.254-.53-1.254-1.183S47.605 0 48.298 0h9.408c.693 0 1.255.53 1.255 1.183s-.562 1.183-1.255 1.183ZM28.854 83.928c-.693 0-1.255-.529-1.255-1.182V57.314H17.563v25.432c0 .653-.562 1.182-1.254 1.182-.693 0-1.255-.529-1.255-1.182V56.132c0-.654.562-1.183 1.255-1.183h12.545c.692 0 1.254.53 1.254 1.183v26.614c0 .653-.562 1.182-1.254 1.182Z"
      fill={outlineColor}
    />
    <path
      d="M20.805 72.1h-.106c-.692 0-1.254-.53-1.254-1.183s.562-1.183 1.254-1.183h.106c.692 0 1.254.53 1.254 1.183 0 .654-.561 1.183-1.254 1.183ZM95.864 84l-94.61-.07C.56 83.927-.002 83.398 0 82.745c0-.653.562-1.183 1.254-1.183h.001l94.61.071c.693 0 1.255.53 1.254 1.184 0 .653-.562 1.182-1.255 1.182Z"
      fill={outlineColor}
    />
    <path d="M58.334 59.141H45.789v14.733h12.545V59.141Z" fill={secondColor} />
    <path
      d="M55.198 72.1H42.653c-.692 0-1.255-.53-1.255-1.183V56.132c0-.654.563-1.183 1.255-1.183h12.545c.692 0 1.254.53 1.254 1.183v14.785c0 .654-.562 1.183-1.254 1.183Zm-11.29-2.366h10.035v-12.42H43.907v12.42Z"
      fill={outlineColor}
    />
    <path
      d="M57.08 72.1H40.77c-.692 0-1.254-.53-1.254-1.183s.562-1.183 1.255-1.183h16.308c.693 0 1.255.53 1.255 1.183 0 .654-.562 1.183-1.255 1.183Z"
      fill={outlineColor}
    />
    <path d="M55.198 20.646H42.653v14.786h12.545V20.646Z" fill="#fff" />
    <path
      d="M55.198 36.614H42.653c-.692 0-1.255-.53-1.255-1.182V20.646c0-.653.563-1.183 1.255-1.183h12.545c.692 0 1.254.53 1.254 1.183v14.786c0 .653-.562 1.182-1.254 1.182Zm-11.29-2.365h10.035v-12.42H43.907v12.42Z"
      fill={outlineColor}
    />
    <path
      d="M57.08 36.614H40.77c-.692 0-1.254-.53-1.254-1.182 0-.653.562-1.183 1.255-1.183h16.308c.693 0 1.255.53 1.255 1.183s-.562 1.182-1.255 1.182Z"
      fill={outlineColor}
    />
    <path d="M28.854 20.646H16.309v14.786h12.545V20.646Z" fill="#fff" />
    <path
      d="M28.854 36.614H16.309c-.693 0-1.255-.53-1.255-1.182V20.646c0-.653.562-1.183 1.255-1.183h12.545c.692 0 1.254.53 1.254 1.183v14.786c0 .653-.562 1.182-1.254 1.182Zm-11.29-2.365h10.035v-12.42H17.563v12.42Z"
      fill={outlineColor}
    />
    <path
      d="M30.735 36.614H14.427c-.693 0-1.255-.53-1.255-1.182 0-.653.562-1.183 1.255-1.183h16.308c.693 0 1.255.53 1.255 1.183s-.562 1.182-1.255 1.182Z"
      fill={outlineColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.576 65.015c0-.864.365-1.692 1.015-2.307a3.561 3.561 0 0 1 2.448-.958h.001c.918 0 1.8.343 2.449.958a3.177 3.177 0 0 1 1.015 2.307v17.73h-6.928v-17.73Z"
      fill="#fff"
    />
    <path
      d="M82.504 83.928h-6.928c-.693 0-1.254-.529-1.254-1.182V65.014c0-1.184.49-2.3 1.38-3.142a4.823 4.823 0 0 1 3.338-1.306c1.264 0 2.45.464 3.339 1.307.89.842 1.38 1.957 1.38 3.14v17.732c0 .653-.562 1.182-1.255 1.182Zm-5.673-2.365h4.419V65.015c0-.553-.23-1.076-.65-1.472-.83-.788-2.29-.786-3.12 0-.419.396-.65.92-.65 1.472v16.548Z"
      fill={outlineColor}
    />
    <path
      d="M79.04 62.933c-.693 0-1.255-.53-1.255-1.183V17.512c0-1.834.758-3.557 2.133-4.853 1.37-1.298 3.2-2.014 5.148-2.014h12.478c.693 0 1.255.53 1.255 1.183s-.562 1.183-1.255 1.183H85.066c-1.276 0-2.474.468-3.372 1.319-.904.851-1.4 1.98-1.4 3.181V61.75c0 .654-.561 1.183-1.254 1.183Z"
      fill={outlineColor}
    />
    <path
      d="M92.101 21.41c-3.42 0-6.203-2.625-6.203-5.85 0-.652.563-1.182 1.255-1.182.693 0 1.254.53 1.254 1.182 0 1.921 1.658 3.484 3.694 3.484 2.037 0 3.694-1.563 3.694-3.484 0-.652.562-1.182 1.255-1.182.693 0 1.254.53 1.254 1.182 0 3.225-2.782 5.85-6.203 5.85Z"
      fill={color}
    />
    <path
      d="M67.115 9.463H4.391c-.693 0-1.255-.53-1.255-1.183s.562-1.183 1.255-1.183h62.724c.693 0 1.255.53 1.255 1.183s-.562 1.183-1.255 1.183Z"
      fill={outlineColor}
    />
  </svg>
);

Apartment.propTypes = {
  color: PropTypes.string,
  outlineColor: PropTypes.string,
  secondColor: PropTypes.string
};

export default Apartment;
